
class ConfirmActionModalController {
    
    private close:Function; //injected from modal-service

    public heading : string;
    public message : string;
    public confirmButotnText : string;
	
	// @ngInject
	constructor(){}
	
	public $onInit = () => {
	    
	    if(!this.heading){
	        this.heading = "Confirm";
	    }
	    
	    if(!this.message){
	        this.message = 'Are you sure you want to do this action';
	    }
	    
	    if(!this.confirmButotnText){
	        this.confirmButotnText = "Confirm";
	    }
	}
	
	public onConfirm = () => {
	    this.closeModal(true);
	}
	
    private closeModal = ( confirm = false ) => {
		this.close?.(confirm);
    }
}

class ConfirmActionModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    heading: "<",
	    message: "=?",
	    confirmButtonText: "=?",
	    close:'=?',
	};

	public controller = ConfirmActionModalController;
	public controllerAs = 'confirmActionModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/confirm-action-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { ConfirmActionModal };
